<template>
    <v-uploader
        :url="url"
        draggable
        :disabled="disabled"
        :data="{
            file_size_limit: '2MB',
            file_types: typeLimit,
        }"
        :size-limit="'2MB'"
        :type-limit="typeLimit"
        :show-list="false"
        class="upload"
        form-key="lbf-file-upload"
        :show-progress="false"
        @complete="uploadComplete"
    >
        <div class="upload-content">
            <div class="upload-icon">
                <v-icon name="basic_upload2_line" remote size="24" />
            </div>
            <div class="upload-text">
                <div v-if="!isMainCorp">
                    {{ $t('点击上传文件') }}
                    <div>{{ $t('图片小于2M，格式： jpg、gif、jpeg、png') }}</div>
                </div>
                <div v-else>
                    {{ $t('点击选择或拖动文件到此区域') }}
                    <div>{{ $t('支持图片和PDF文件，最多上传5个附件，且每个文件小于2M') }}</div>
                </div>
            </div>
        </div>
    </v-uploader>
</template>
<script>
const qualificationUrl = '/mng/account/relatedCorp/uploadQualification?type=upload';
const fileUrl = '/mng/account/corpInfo/UploadAttachment?type=upload';
export default {
    props: {
        isMainCorp: {
            type: Boolean,
            default: false,
        },
        cur: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        url() {
            return this.isMainCorp ? fileUrl : qualificationUrl;
        },
        typeLimit() {
            return this.isMainCorp ? '*.jpg;*.gif;*.jpeg;*.png;*.pdf' : '*.jpg;*.gif;*.jpeg;*.png;';
        },
    },
    methods: {
        uploadComplete(data) {
            const status = data?.status;
            let res;
            switch (status) {
                case 0:
                    res = data?.data?.data || {};
                    if (res.code === 0 || res.r === 0) {
                        const fileInfo = { ...res, cur: this.cur };
                        this.$emit('uploadComplete', fileInfo);
                    } else {
                        this.$message.error(res.msg || res.message || this.$t('上传失败'));
                    }
                    break;
                case 1:
                    this.$message.error(this.$t('文件类型错误'));
                    break;
                case 2:
                    this.$message.error(this.$t('文件大小超过限制'));
                    break;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.upload {
    width: 100%;
    &-content {
        padding: calc(var(--spacing-loose) - 5px) calc(var(--spacing-loose) - 10px);
        box-sizing: border-box;
    }
    &-icon {
        margin-bottom: var(--spacing-loose);
    }
    &-text {
        color: var(--color-text-caption);
        font-size: 14px;
    }
    /deep/ .v-uploader__wrap {
        width: 100%;
        .is-disabled {
            background: var(--color-fill-disable);
        }
    }
}
</style>
